namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoApDtRow {
        PromoId?: string;
        ItemType?: PromoItemType;
        ItemCode?: string;
        PromoType?: PromoType;
        PromoDiscPc?: number;
        PromoPrice?: number;
        GroupCode1?: string;
        GroupCode2?: string;
        DescItem?: string;
        GpNormal?: number;
        GpPromo?: number;
        Id?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsPromoApDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PromoId';
        export const localTextPrefix = 'SalePromoCamp.PsPromoApDt';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            PromoId = "PromoId",
            ItemType = "ItemType",
            ItemCode = "ItemCode",
            PromoType = "PromoType",
            PromoDiscPc = "PromoDiscPc",
            PromoPrice = "PromoPrice",
            GroupCode1 = "GroupCode1",
            GroupCode2 = "GroupCode2",
            DescItem = "DescItem",
            GpNormal = "GpNormal",
            GpPromo = "GpPromo",
            Id = "Id",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
